/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/train'
export default icon
